import React from 'react';
import { func, object, bool } from 'prop-types';
import { SocialShareMenu as SocialShareComponent } from '@kyruus/social-share';

import { IconWrapper } from './styles';
import { specialtyNames } from '../provider/utils';
import { formattedProviderName, pageTitle } from '../profile-v9/profile-metas';
import { getProviderProfileUrl } from 'Common/urls/provider';

export const IconWithLabel = ({
  icon,
  label,
  onClick,
  iconPosition = 'right',
  ...props
}) => {
  return (
    <IconWrapper onClick={onClick} iconPosition={iconPosition} {...props}>
      <span>{label}</span>
      <span>{icon}</span>
    </IconWrapper>
  );
};

const SocialShareMenu = ({ profile, config, intl }) => {
  const socialShareConfig = config['social_share'] || {};
  const showEmail = !!socialShareConfig.email;
  const showFacebook = !!socialShareConfig.facebook;
  const showTwitter =
    !!socialShareConfig.twitter || !!socialShareConfig.twitterX;

  const provider = profile.provider;
  const providerName = formattedProviderName({ provider, intl });
  const specialties = specialtyNames(provider).join(', ');
  const title = pageTitle({
    providerName,
    specialties,
    intl
  });
  const url = getProviderProfileUrl(
    config.primary_domain || config.host,
    provider
  );
  return (
    <SocialShareComponent
      url={url}
      text={title}
      showPrint={false}
      showEmail={showEmail}
      showFacebook={showFacebook}
      showTwitterX={showTwitter}
      showLabels={true}
      intl={intl}
    />
  );
};

SocialShareMenu.defaultProps = {
  anchorEl: null
};

SocialShareMenu.propTypes = {
  anchorEl: object,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  profile: object.isRequired,
  config: object.isRequired,
  messages: object.isRequired,
  intl: object.isRequired
};

export default SocialShareMenu;
